import React, { useEffect, useState } from 'react'
import api from '../components/api'


const Modal = (props) => {

    var eventoFoto_id = props.eventoFoto_id
    var linkAPI = props.linkAPI

    var [legenda, setLegenda] = useState('')
    var [foto, setFoto] = useState()
    var [ordem, setOrdem] = useState()


    function carregaFoto() {

        api.get(`eventoFoto/${eventoFoto_id}`).then((result) => {

            var data = result.data[0]

            setFoto(data.arquivo)
            setLegenda(data.legenda)
            setOrdem(data.ordem == null ? '' : data.ordem)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function apagaFoto() {



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    
                    api.delete(`eventoFoto/${eventoFoto_id}`).then((result) => {

                        if (result.data.alerta == 'ok') {

                            window.$("#modalFoto").modal('hide');
                            window.toastr.success('Apagado com sucesso!')
                            props.carregaFotos()
                            props.totalizaFotosEvento()

                        }

                    }).catch((err) => {

                        console.log(err.response)
                        window.toastr.error('Ocorreu um erro, por favor contacte o administrador do sistema.')

                    })
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    function salvaFoto() {

        var dataPost = {

            legenda: legenda,
            ordem: ordem,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
		    title: 'Confirmação',
		    content: 'Confirma a alteração?',
		    buttons: {
		        Sim: function () {

                    api.put(`eventoFoto/${eventoFoto_id}`, dataPost).then((result) => {

                        if (result.data.alerta == 'ok') {

                            //window.$("#modalFoto").modal('hide');
                            window.toastr.success('Salvo com sucesso!')
                            props.carregaFotos()
    
                        }
                        

                    }).catch((err) => {

                        console.log(err.response)
                        window.toastr.error('Ocorreu um erro, por favor contacte o administrador do sistema.')

                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    useEffect(() => {

        if (eventoFoto_id) {

            carregaFoto()

        }

    }, [eventoFoto_id])


    return (

        <div>

            <div className="modal fade" id="modalFoto" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">Foto</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    

                                    <div className="col-md-12">

                                        <img src={`${linkAPI}/uploads/fotosEventos/${foto}`} className='img-responsive' />
                                        <br/>
                                    </div>

                                    <div className="col-md-7">
                                        <div class="form-group">
                                            <label>Legenda</label>
                                            <input type="text" value={legenda} className="form-control" onChange={event => setLegenda(event.target.value)} maxLength="1000"  />
                                                            
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div class="form-group">
                                            <label>Ordem</label>
                                            <input type="text" className="form-control" value={ordem} placeholder='Deixar em branco para ordenar por ordem de upload' 
                                            pattern="[0-9]*" 
                                            onChange={(e) =>
                                                setOrdem((v) => (e.target.validity.valid ? e.target.value : v))
                                            }
                                            />
                                                            
                                        </div>
                                    </div>


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="button" className="btn btn-danger" onClick={() => apagaFoto()} >Apagar</button>
                            <button type="button" className="btn btn-success" onClick={() => salvaFoto()}>Salvar</button>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )

}

export default Modal